// extracted by mini-css-extract-plugin
export var blackBg = "StaggeredTiles-module--blackBg--9ab0d";
export var blueOverlay = "StaggeredTiles-module--blueOverlay--5d228";
export var icon = "StaggeredTiles-module--icon--29db5";
export var image = "StaggeredTiles-module--image--f3ab7";
export var imageBg = "StaggeredTiles-module--imageBg--4e9bb";
export var lightBlueBg = "StaggeredTiles-module--lightBlueBg--5e0b5";
export var tileContainer = "StaggeredTiles-module--tileContainer--6c25a";
export var tileItem = "StaggeredTiles-module--tileItem--17eb7";
export var tileWrapper = "StaggeredTiles-module--tileWrapper--9af8a";
export var tilesContainer = "StaggeredTiles-module--tilesContainer--54680";